import makeApiCall from "../master/axiosIndex";

const STATIC_FILES_DATA = [
  {
    order: 0,
    module: "Work Boq",
    moduleFileType: "signature.png",
  }
];

const workBoqApis = {
  getWorkBoq: (params: any) =>
    makeApiCall({
      url: `/work-boq/list`,
      method: "get",
      params,
    }),
  getPendingApprovalsWorkBoq: (params: any) =>
    makeApiCall({
      url: `/work-boq/pending-approvals`,
      method: "get",
      params,
    }),
  createWorkBoq: (data: any) =>
    makeApiCall({ url: `/work-boq/create`, method: "post", data }),
  updateWorkBoq: (workBoqId: any, data: any) =>
    makeApiCall({
      url: `/work-boq/update`,
      method: "put",
      data,
    }),
  getWorkBoqById: (workBoqId: any) =>
    makeApiCall({
      url: `/work-boq/id/${workBoqId}`,
      method: "get",
    }),
  approveWorkBoq: (workBoqId: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();
    const requestBody = {
      workBoqId,
      action: "Approved",
      filesData: STATIC_FILES_DATA,
    };
    formData.append("workBoqApproval", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));
    return makeApiCall<any>({ method: "post", url: `/work-boq/approve`, data: formData });
  },
  rejectWorkBoq: (workBoqId: number, reason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();
    const requestBody = {
      workBoqId,
      action: "Rejected",
      reason,
      filesData: STATIC_FILES_DATA,
    };
    formData.append("workBoqApproval", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));
    return makeApiCall<any>({ method: "post", url: `/work-boq/approve`, data: formData });
  },
  workBoqDropdownAlongWithCategory: (
    siteId: any,
    dropdownFor: any,
    flowType?: any
  ) =>
    makeApiCall({
      url: `/work-boq/dropdown/${siteId}`,
      method: "get",
      params: flowType ? { dropdownFor, flowType } : { dropdownFor },
    }),
  getWorkBoqByIdWithCategory: (workBoqId: any, workCategoryId: any) =>
    makeApiCall({
      url: `/work-boq/id/${workBoqId}`,
      method: "get",
      params: { workCategoryId },
    }),
};

export default workBoqApis;
